<template>
    <app-layout :racingstars="$page.props.racingstars" :jetstream="$page.props.jetstream" :user="$page.props.user" title="Dashboard">
        <template #header>
            Store
        </template>

        <div class="flex mx-auto my-4 space-x-3 px-2 lg:px-6">
            <button
            @click="setFilter('All')"
            :class="{
                'bg-racing-stars-yellow text-black': itemFilter === 'All',
                'bg-gray-900 text-white': itemFilter !== 'All',
            }"
            class="shadow-xl font-bold rounded-md p-1 w-36"
            >
            All
            </button>
            <button
            @click="setFilter('Products')"
            :class="{
                'bg-racing-stars-yellow text-black': itemFilter === 'Products',
                'bg-gray-900 text-white': itemFilter !== 'Products',
            }"
            class="shadow-xl font-bold rounded-md p-1 w-36"
            >
            Products
            </button>
            <button
            @click="setFilter('Stars')"
            :class="{
                'bg-racing-stars-yellow text-black': itemFilter === 'Stars',
                'bg-gray-900 text-white': itemFilter !== 'Stars',
            }"
            class="shadow-xl font-bold rounded-md p-1 w-36"
            >
            Stars
            </button>
            <button
            @click="setFilter('Boosts')"
            :class="{
                'bg-racing-stars-yellow text-black': itemFilter === 'Boosts',
                'bg-gray-900 text-white': itemFilter !== 'Boosts',
            }"
            class="shadow-xl font-bold rounded-md p-1 w-36"
            >
            Boosts
            </button>
        </div>

        <div class="p-2 px-2 lg:px-6" v-if="products && (itemFilter === 'All' || itemFilter === 'Products')">
            <!-- <img class="inline h-16 w-fit mx-auto" src="images/coin-and-tokens/stars-text.svg" /> -->

            <div class="flex mb-4">
                <ShoppingCartIcon class="w-10 mr-3 text-white"/>
                <span class="text-4xl font-bold text-white">Products</span>
            </div>

            <div class="items-center justify-center w-full">
                <div class="flex flex-col lg:flex-row flex-wrap">
                    <Products :products="products" :user="user" @getAllProduct="getStoreProducts()"/>
                </div>
            </div>
        </div>
        
        <div class="p-2 px-2 lg:px-6" v-if=" (itemFilter === 'All' || itemFilter === 'Stars')">
            <div class="flex mb-4">
                <img :src="asset('images/coin-and-tokens/token-optimised.svg')" class="w-10 mr-3 rounded-full"/>
                <span class="text-4xl font-bold text-white">Star Packs</span>
            </div>
            
            <div class="items-center justify-center" v-if="!showMobilePurchaseMenu">
                <packages :packages="star_packs" :user="user" @openPurchaseMenu="openRequiredPurchaseMenu" />
            </div>
        </div>
        
        <div class="p-2 px-2 lg:px-6" v-if="$page.props.boosters && (itemFilter === 'All' || itemFilter === 'Boosts')">
            <div class="flex mb-4">
                <LightningBoltIcon class="w-10 mr-3 text-purple-600 rounded-full border border-purple-600"/>
                <span class="text-4xl font-bold text-white">Boosters</span>
            </div>

            <div class="flex flex-col lg:flex-row">
                <div v-for="item in racingstars.packages.booster_packs" :key="item.name" class=" lg:mr-4 in-out mb-4 delay-150 duration-300 col-span-1 col-sm transition-all duration-900 ease-in-out col-sm" :class="[item.span && isMobile ? 'col-span-2' : 'col-span-1', item.tag == 'double_runner' ? 'opacity-50' : 'opacity-100']">

                    <div
                            :class="{
                        'cursor-not-allowed': item.price >= $page.props.user.play_tokens,
                    }"
                            class = "w-full lg:w-80 transition ease-in-out delay-150 col-span-1 shadow-2xl">
                        <div class="rounded-lg shadow bg-gray-900 bg-no-repeat flex w-full">
                            <div class="flex border-2 border-gray-200 border-opacity-10 rounded-lg w-full p-2">
                                <div class="flex ml-3">
                                    <img class="w-48 my-auto" :src="asset(item.icon)" />
                                </div>

                                <div class="flex flex-col w-full ml-3 p-2">
                                    <span class="w-full flex font-bold text-white text-left">
                                        <p class="text-md sm:text-lg sm:h-fit mb-0">{{item.name}}</p>
                                    </span>
                                    
                                    <span class="flex pt-1">
                                        <p class="inline box-shadow-sm text-white text-md sm:text-xl my-auto">{{item.price}}</p>
                                        <img class="inline w-[22px] my-auto stroke-2 ml-2" src="images/coin-and-tokens/tokens-optimised.svg" />
                                    </span>

                                    <p  class="text-md sm:text-lg w-26 sm:w-fit text-left h-fit sm:h-fit mb-0 
                                    sm:mb-1 leading-tight text-white rounded-full pb-1">Owned: {{boosters[item.tag]}}</p>

                                    <button @click="boosterConfirmationModal(item.tag)" :disabled="item.price >= $page.props.user.play_tokens"
                                            class="shadow-xl font-bold rounded-md p-1 w-full bg-racing-stars-yellow text-black mb-3 hover:bg-yellow-400"
                                        >
                                        Purchase
                                    </button>
                                    
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>

        <tw-modal :show="showForm" width="1250" @close="showForm = false">
            <form class="" ref="paymentForm" id="st-form" @submit.prevent="validateResponse()" :action="route('tokens')" method="POST">
                <div class="grid grid-cols-2" >
                    <div class="h-full flex flex-col dark:bg-white shadow-xl overflow-y-scroll col-span-2 md:col-span-1 p-12 dark:text-gray-800" v-if="showTerms">
                        <div class="flex items-start justify-between">
                            <h2 class="text-lg font-medium text-gray-900 mb-4">Terms &amp; Conditions</h2>
                            <div class="ml-3 h-7 flex items-center">
                                <button type="button" class="bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" @click="showTerms = false">
                                    <span class="sr-only">Close panel</span>
                                    <XIcon class="h-6 w-6" aria-hidden="true" />
                                </button>
                            </div>
                        </div>
                        <div class="page" v-html="terms"></div>
                    </div>
                    <div class="col-span-2 md:col-span-1 p-12 dark:bg-white" v-else-if="!useBalance">
                        <Checkout @close="showForm = false" class="md:h-[550px] my-auto" :user="$page.props.user" :package="selectedTokenPackage"/>
                        <div class="mt-5 sm:mt-6 flex justify-end">
                            <tw-button :ignore-dark-mode="true" class="mr-2" v-if="$page.props.user.balance && $page.props.user.balance >= selectedTokenPackage.price" :secondary="true" @click="useBalance = true">
                                Use Balance
                            </tw-button>
                        </div>
                    </div>
                    <div class="col-span-2 md:col-span-1 p-12 dark:bg-white" v-else>
                        <div>
                            <h2 class="text-lg leading-6 font-medium text-gray-900 mb-4">Balance details</h2>
                            <div class="pb-1 text-gray-900 mb-4">
                                Current Balance: {{ formatter.format($page.props.user.balance / 100) }}
                            </div>
                            <div class="pb-1">
                                <label class="flex items-center justify-end">
                                    <jet-checkbox :ignore-dark-mode="true" :value="form.terms" v-model:checked="form.terms" :error="form.errors.terms" />
                                    <span class="ml-2 text-sm text-gray-600">Accept <a href="#" @click.prevent="showTerms = !showTerms">Terms &amp; Conditions</a></span>
                                </label>
                            </div>
                        </div>
                        <div class="mt-5 sm:mt-6 flex justify-end">
                            <tw-button class="mr-2" :ignore-dark-mode="true" :secondary="true" @click="useBalance = false">
                                Use Card
                            </tw-button>
                            <button type="button" class="rounded-md border border-transparent shadow-sm px-4 py-2 bg-racing-stars-yellow text-base font-medium text-gray-800 hover:bg-racing-stars-yellow focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-racing-stars-yellow sm:text-sm disabled:opacity-50 disabled:cursor-not-allowed" @click="purchaseWithBalance" :disabled="form.processing || !form.terms">
                                <svg v-if="form.processing" role="status" class="inline mr-3 w-4 h-4 text-white animate-spin" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="#1f2938"/>
                                    <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="#111828"/>
                                </svg>
                                Purchase
                            </button>
                        </div>
                    </div>
                    <div class="flex flex-col col-span-2 md:col-span-1 bg-gray-800 text-white p-12">
                        <div class="border-b border-gray-700 pb-5">
                            <h2 class="text-lg leading-6 font-medium mb-4">Amount Due</h2>
                            <span class="text-3xl font-semibold">{{ formatter.format(selectedTokenPackage.price/100) }}</span>
                        </div>
                        <div class="border-b border-gray-700 pb-5 mt-4">
                            <div class="grid grid-cols-3">
                                <div class="col-span-1">
                                    <div class="rounded-md flex justify-start items-center">
                                        <div class="bg-white rounded-md flex justify-center items-center p-4">
                                            <div class="rounded-full w-8 h-8 md:w-12 md:h-12 border-0 md:border-2 border-gray-900 flex justify-center items-center">
                                                <span class="text-gray-800 font-medium text-sm md:text-xl">
                                                    {{ parseInt(selectedTokenPackage.play_tokens) }}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-span-1 flex items-center font-medium">
                                    {{ parseInt(selectedTokenPackage.play_tokens)}} Stars
                                </div>
                                <div class="col-span-1 flex items-center justify-end font-medium">
                                    {{ formatter.format(selectedTokenPackage.price/100) }}
                                </div>
                            </div>
                        </div>
                        <div class="grow flex items-end">
                            <div class="border-t w-full border-gray-700 grid grid-cols-2 pt-8">
                                <div class="col-span-1">
                                    <h2 class="text-lg leading-6 font-medium mb-4">Total</h2>
                                </div>
                                <div class="col-span-1">
                                    <h2 class="text-lg text-right leading-6 font-medium mb-4">
                                        {{ formatter.format(selectedTokenPackage.price/100) }}
                                    </h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </form>
        </tw-modal>
        <!-- Mobile -->

        <div v-if="showMobilePurchaseMenu" class="lg:hidden items-center justify-center relative">
            <form ref="mobilePaymentForm" id="st-form" @submit.prevent="validateResponse()" :action="route('tokens')" method="POST">
                <div class="grid grid-cols-2" style="height: 430px;">
                    <div class="h-screen flex flex-col dark:bg-white shadow-xl overflow-y-scroll col-span-2 md:col-span-1 p-12 dark:text-gray-800" v-if="showTerms">
                        <div class="flex items-start justify-between">
                            <h2 class="text-lg font-medium text-gray-900 mb-4">Terms &amp; Conditions</h2>
                        </div>
                        <div class="page" v-html="terms"></div>
                    </div>
                    <div class="col-span-2 md:col-span-1 p-3 pb-0 dark:bg-white relative" v-else-if="!useBalance">
                        <div>
                            <button type="button" class="bg-white dark:bg-racing-stars-yellow rounded-md text-gray-400 dark:text-gray-800 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:dark:ring-racing-stars-yellow absolute top-2 right-2" @click="showMobilePurchaseMenu = false">
                                <span class="sr-only">Close panel</span>
                                <XIcon class="h-6 w-6" aria-hidden="true" />
                            </button>
                            <div class="pb-1">
                                <p class="text-gray-800 mb-4 mt-6 text-xs">Depending on your card issuer and the amount of purchase, you may be required to authenticate with your bank using 3D secure multiple times. This is normal and you will only be charged for one purchase.</p>
                                <tw-input :ignore-dark-mode="true" label="Card Number" v-model="form.card_number" placeholder="1234 1234 1234 1234" autocomplete="cc-number" :error="form.errors.card_number" v-cardformat:formatCardNumber />
                            </div>
                            <div class="grid grid-cols-2 gap-2 pb-2 pt-2">
                                <div class="col-span-1">
                                    <tw-input maxlength="7" :ignore-dark-mode="true" label="Expiry" v-model="form.expiry_date" placeholder="MM/YY" autocomplete="cc-exp" :error="form.errors.expiry_date" v-cardformat:formatCardExpiry />
                                </div>
                                <div class="col-span-1">
                                    <tw-input :ignore-dark-mode="true" label="CSV" v-model="form.csv" placeholder="123" :error="form.errors.csv" autocomplete="cc-csc" class="col-span-1" v-cardformat:formatCardCVC />
                                </div>
                            </div>
                            <!-- <div class="pb-1">
                                <label class="flex items-center justify-end">
                                    <jet-checkbox :ignore-dark-mode="true" :value="form.save_credentials" v-model:checked="form.save_credentials" :error="form.errors.save_credentials" />
                                    <span class="ml-2 text-sm text-gray-600">Save Card Details</span>
                                </label>
                            </div> -->
                            <div class="pb-1">
                                <label class="flex items-center justify-end">
                                    <jet-checkbox :ignore-dark-mode="true" :value="form.terms" v-model:checked="form.terms" :error="form.errors.terms" />
                                    <span class="ml-2 text-sm text-gray-600">Accept <a href="#" @click.prevent="showTerms = !showTerms">Terms &amp; Conditions</a></span>
                                </label>
                            </div>
                            <!-- <p v-if="form.errors.payment" class="mt-2 text-sm text-red-600" id="email-error">{{ form.errors.payment }}</p> -->
                        </div>
                        <div class="mt-2 sm:mt-6 flex justify-end">
                            <tw-button :ignore-dark-mode="true" class="mr-2" v-if="$page.props.user.balance && $page.props.user.balance >= selectedTokenPackage.price" :secondary="true" @click="useBalance = true">
                                Use Balance
                            </tw-button>
                            <button id="purchase" type="button" class="rounded-md border border-transparent shadow-sm px-4 py-2 bg-racing-stars-yellow text-base font-medium text-gray-800 hover:bg-racing-stars-yellow focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-racing-stars-yellow sm:text-sm disabled:opacity-50 disabled:cursor-not-allowed" @click="purchase" :disabled="form.processing || !form.terms || resubmitting">
                                <svg v-if="form.processing || resubmitting" role="status" class="inline mr-3 w-4 h-4 text-white animate-spin" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="#1f2938"/>
                                    <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="#111828"/>
                                </svg>
                                Purchase
                            </button>
                        </div>
                        <div class="flex mt-4 text-center dark:text-gray-800">
                            <small class="text-xs"> Stars Ltd &#124; Number Sixty One, Alexandra Road, Lowestoft, Suffolk, NR32 1PL</small>
                        </div>
                    </div>
                    <div class="col-span-2 md:col-span-1 p-3 pb-0 dark:bg-white" v-else>
                        <div>
                            <h2 class="text-lg leading-6 font-medium text-gray-900 mb-4">Balance details</h2>
                            <div class="pb-1 text-gray-900 mb-4">
                                Current Balance: {{ formatter.format($page.props.user.balance / 100) }}
                            </div>
                            <div class="pb-1">
                                <label class="flex items-center justify-end">
                                    <jet-checkbox :ignore-dark-mode="true" :value="form.terms" v-model:checked="form.terms" :error="form.errors.terms" />
                                    <span class="ml-2 text-sm text-gray-600">Accept <a href="#" @click.prevent="showTerms = !showTerms">Terms &amp; Conditions</a></span>
                                </label>
                            </div>
                        </div>
                        <div class="mt-2 sm:mt-6 flex justify-end">
                            <tw-button class="mr-2" :ignore-dark-mode="true" :secondary="true" @click="useBalance = false">
                                Use Card
                            </tw-button>
                            <button type="button" class="rounded-md border border-transparent shadow-sm px-4 py-2 bg-racing-stars-yellow text-base font-medium text-gray-800 hover:bg-racing-stars-yellow focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-racing-stars-yellow sm:text-sm disabled:opacity-50 disabled:cursor-not-allowed" @click="purchaseWithBalance" :disabled="form.processing || !form.terms">
                                Purchase
                            </button>
                        </div>
                    </div>
                    <div class="flex flex-col col-span-2 md:col-span-1 bg-gray-800 text-white items-center justify-center">
                        <div class="grid grid-cols-2">
                            <div class="col-span-1 flex items-center font-medium">
                                {{ parseInt(selectedTokenPackage.play_tokens) + parseInt(selectedTokenPackage.free_tokens) }} tokens
                            </div>
                            <div class="col-span-1 flex items-center justify-end font-medium">
                                {{ formatter.format(selectedTokenPackage.price/100) }}
                            </div>
                        </div>
                    </div>
                </div>
            </form>
            <div v-if="showTerms" class="ml-3 h-7 flex items-center absolute right-2 top-2">
                <button type="button" class="bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" @click="showTerms = false">
                    <span class="sr-only">Close panel</span>
                    <XIcon class="h-6 w-6" aria-hidden="true" />
                </button>
            </div>
        </div>

        <jet-primary-confirmation-modal extraClass="z-50 relative" :show="isConfirmationModal">
            <template #title>
                Buy booster
            </template>
            <template #content>
                Are you sure you would like to purchase this booster?
            </template>
            <template #footer>
                <jet-secondary-button @click="isConfirmationModal = false">
                    Cancel
                </jet-secondary-button>
                <jet-primary-button class="ml-2" @click="exchangeBoosters(selectedBooster)" >
                    Confirm
                </jet-primary-button>
            </template>
        </jet-primary-confirmation-modal>

    </app-layout>
</template>

<script>
import Checkout from '@/Pages/Store/Partials/Checkout'
import AppLayout from '@/Layouts/Layout'
import Play from '@/Global/Play/Play'
import Scores from '@/Global/Scores/Scores'
import Leagues from '@/Global/Leagues/Leagues'
import Banners from '@/Global/Banners/Banners'
import Videos from '@/Global/Videos/Videos'
import Popper from 'vue3-popper'
import { ShoppingBagIcon } from '@heroicons/vue/outline'
import RacingStarsIcon from '@/Global/RacingStarsIcon.vue'
import TwButton from '@/Global/Elements/TwButton.vue'
import { ref, getCurrentInstance, onMounted, watch, computed, reactive } from 'vue'
import Packages from './Partials/Packages'
import Products from './Partials/Products'
import PrimaryCta from './Partials/PrimaryCta'
import JetCheckbox from '@/Jetstream/Checkbox.vue'
import { XIcon, LightningBoltIcon, ShoppingCartIcon } from '@heroicons/vue/outline'
import moment from 'moment'
import { useGtm } from '@gtm-support/vue-gtm'
import { Inertia } from '@inertiajs/inertia'
import { useStore } from 'vuex'
import TwModal from "@/Global/Elements/TwModal.vue";
import JetPrimaryConfirmationModal from '@/Jetstream/PrimaryConfirmationModal.vue'
import JetPrimaryButton from '@/Jetstream/PrimaryButton.vue'
import JetSecondaryButton from '@/Jetstream/SecondaryButton.vue'

export default {
    props: {
        meetings: {
            type: Object,
            default: {},
        },
        user: Object,
        racingstars: Object,
        star_packs: Object,
        errors: Object,
        terms: String,
    },

    components: {
        TwModal,
        Checkout,
        AppLayout,
        Play,
        Scores,
        Leagues,
        Banners,
        Videos,
        Popper,
        ShoppingBagIcon,
        Inertia,
        PrimaryCta,
        JetCheckbox,
        RacingStarsIcon,
        XIcon,
        TwButton,
        Packages,
        Products,
        JetPrimaryConfirmationModal,
        JetPrimaryButton,
        JetSecondaryButton,
        LightningBoltIcon,
        ShoppingCartIcon
    },

    setup(props) {
        const boosters = ref(0)
        const products = ref([])
        const windowWidth = ref(window.innerWidth)
        const isConfirmationModal = ref(false)
        const selectedBooster = ref(null)
        const itemFilter = ref('All')

        const setFilter = (filterOption) => {
            itemFilter.value = filterOption;
        };

        const setWindowDimensions = () => {
            windowWidth.value = window.innerWidth
        }

        const getBoosters = () => {
            axios.get(route('api.boosters.get'))
                .then(response => {
                        boosters.value = response.data
                    }
                );
        }

        const getStoreProducts = () => {
            axios.get(route('api.products.get'))
            .then(response => {
                    products.value = response.data
                }
            );
        }

        const isMobile = computed(() => {
            return windowWidth.value < 1024;
        })

        onMounted(() => {
            setWindowDimensions()

            getBoosters()

            getStoreProducts()

            window.addEventListener('resize', setWindowDimensions)

        })

        const boosterConfirmationModal = (name) => {
            selectedBooster.value = name;
            isConfirmationModal.value = true;
        }

        const exchangeBoosters = (name) => {
            axios.post(route('api.boosters.exchange'), {
                'booster_name': name,
            }).then(response=>{
                isConfirmationModal.value = false;
                getBoosters();
            });
        }

        /*
        |--------------------------------------------------------------------------
        | Properties
        |--------------------------------------------------------------------------
        */
        /**
         * The VueX store.
         *
         * @type {Object}
         */
        const store = useStore()

        /**
         * Google Tag Manage Instance.
         *
         * @type {Object}
         */
        const gtm = useGtm();

        /**
         * Inertia payment form.
         *
         * @type {Reactive}
         */
        const form = Inertia.form({
            card_number: null,
            expiry_date: null,
            csv: null,
            play_tokens: null,
            type: 'charge',
            terms: false,
            save_credentials: false,
            amount: null,
            transaction_reference: null,
        })

        /**
         * Formatter function required to format currencies/prices correctly.
         *
         * @type {Intl}
         */
        const formatter = new Intl.NumberFormat('en-GB', {
            style: 'currency',
            currency: 'GBP',
        })

        /**
         * Boolean value to indicate whether or not to use balance for payment.
         *
         * @type {Boolean}
         */
        const useBalance = ref(false)

        /**
         * Boolean value to indicate whether or not to show the payment form.
         *
         * @type {Boolean}
         */
        const showForm = ref(false)

        /**
         * The payment form.
         *
         * @type {Object}
         */
        const paymentForm = ref(null)

        /**
         * Boolean value to indicate whether or not to show the terms.
         *
         * @type {Boolean}
         */
        const showTerms = ref(false)

        /**
         * The selected token package.
         *
         * @type {Object}
         */
        const selectedTokenPackage = ref(1)

        /**
         * The st component.
         *
         * @type {Object}
         */
        const st = ref(null)

        /**
         * Whether the payment was succesful
         *
         * @type {Boolean}
         */
        const paymentSuccesful = ref(false)

        const showMobilePurchaseMenu = ref(false)

        const resubmitting = ref(false)

        /**
         * Whether the payment script exists or not
         *
         * @type {Boolean}
         */
        const stScript = ref({
            exists: false,
            jwt: null,
        })

        /*
        |--------------------------------------------------------------------------
        | Methods
        |--------------------------------------------------------------------------
        */

        /**
         * Open the purchase menu and set the appropriate tokens.
         *
         * @param  {Object} tokenPackage The selected package.
         * @return {void}
         */
        const openPurchaseMenu = tokenPackage => {
            selectedTokenPackage.value = tokenPackage
            form.play_tokens = tokenPackage.play_tokens
            form.amount = selectedTokenPackage.value.price

            showForm.value = true
        }


        const openMobilePurchaseMenu = tokenPackage => {
            selectedTokenPackage.value = tokenPackage
            form.play_tokens = tokenPackage.play_tokens
            form.amount = selectedTokenPackage.value.price

            showMobilePurchaseMenu.value = true
        }

        const trackPurchase = (amount) => {
            let baseAmount = amount / 100
            let tokens = parseInt(selectedTokenPackage.value.play_tokens) + parseInt(selectedTokenPackage.value.free_tokens)

            gtm.trackEvent({
                event: 'Star Purchase',
                category: 'Sales',
                action: 'Purchase',
                label: tokens + ' tokens for £' + baseAmount + '.',
                value: baseAmount,
            })
        }

        watch(showMobilePurchaseMenu, (currentValue, oldValue) => {
            if (isMobile.value) {
                store.commit('togglePaymentForm', currentValue)
            }
        })

        /**
         * Post the purchase form and close the purchase form.
         *
         * @return {void}
         */
        const purchaseWithBalance = () => {
            form
                .post('balances', {
                    onSuccess: () => {
                        trackPurchase(form.amount)

                        form.reset()
                        showForm.value = false
                        showMobilePurchaseMenu.value = false
                        paymentSuccesful.value = true
                        useBalance.value = false
                    },

                    onError: errors => {
                        paymentSuccesful.value = false
                    }
                })
        }

        /**
         * Post the purchase form and close the purchase form.
         *
         * @return {void}
         */
        const purchase = () => {
            form.processing = true
            getJWT()
        }

        const validateResponse = data => {
            axios.post('/api/jwt', data)
                .then(response => {
                    let transactionReference = undefined
                    let threeDResponse = undefined

                    let accountCheckErrorCode = undefined
                    let threeDQueryCheckErrorCode = undefined
                    let authErrorCode = undefined

                    let proceed = false
                    let isAuth = false
                    console.log(data)


                    response.data.payload.response.forEach(data => {
                        if (data.requesttypedescription == 'ACCOUNTCHECK' && data.transactionreference != undefined) {
                            transactionReference = data.transactionreference
                            accountCheckErrorCode = data.errorcode
                        }

                        if (data.requesttypedescription == 'THREEDQUERY' && data.threedresponse != undefined) {
                            threeDResponse = data.threedresponse
                            threeDQueryCheckErrorCode = data.errorcode
                        }

                        if (data.requesttypedescription == 'AUTH') {
                            isAuth = true
                            authErrorCode = data.errorcode
                        }
                    })

                    if (transactionReference != undefined) {
                        form.transaction_reference = transactionReference
                        form.type = 'auth'
                    }

                    if (threeDResponse != undefined) {
                        form.response = threeDResponse
                    }

                    let amount = form.amount

                    if (accountCheckErrorCode == 0 && threeDResponse != undefined && threeDQueryCheckErrorCode == 0) {
                        proceed = true
                    }

                    if (accountCheckErrorCode == 0 && threeDResponse == undefined) {
                        proceed = true
                    }

                    if (isAuth && authErrorCode != 0) {
                        proceed = false

                        form.errors.payment = '3D Secure Failed'
                    }

                    if (isAuth && authErrorCode == 0) {
                        delete data.jwt
                        form.type = '3dauth'
                    }

                    if (isAuth && authErrorCode == 0) {
                        proceed = true
                    }

                    if (proceed) {
                        form
                            .transform((data) => ({
                                ...data,
                                amount: null,
                            }))
                            .post('payments', {
                                onSuccess: () => {
                                    trackPurchase(amount)

                                    form.reset()
                                    showForm.value = false
                                    showMobilePurchaseMenu.value = false
                                    paymentSuccesful.value = true
                                    st.value.destroy()
                                    resubmitting.value = false
                                },

                                onError: errors => {
                                    st.value.destroy()

                                    if (errors.payment == 'Soft Decline: 65') {
                                        form.threedquery = true
                                        form.transaction_reference = errors.transaction_reference

                                        delete form.jwt

                                        form.clearErrors()

                                        resubmitting.value = true

                                        purchase()
                                    } else {
                                        paymentSuccesful.value = false
                                    }
                                }
                            })
                    } else {
                        st.value.destroy()
                        paymentSuccesful.value = false
                    }
                })
        }

        const getJWT = () => {
            axios.post('/api/jwt', form)
                .then(response => {
                    loadSCAScript(response.data)
                })
        }

        const createStComponent = (jwt) => {
            if (typeof st.value !== 'function') {
                Inertia.reload()
            }
            setTimeout(() => {
                st.value = SecureTrading({
                    jwt: jwt,
                    submitOnError: false,
                    submitOnSuccess: false,
                    submitCallback: validateResponse,
                    livestatus: props.racingstars.liveStatus,
                })

                st.value.Components({ startOnLoad: true })
            }, 2000)
        }

        const loadSCAScript = (jwt) => {
            if (!stScript.value.exists) {
                let script = document.createElement('script')
                script.src = 'https://webservices.securetrading.net/js/v3/st.js'
                script.id = 'st'

                document.body.appendChild(script)

                stScript.value = {
                    exists: true,
                    jwt: jwt,
                }
            } else {
                createStComponent(jwt)
            }
        }

        const packageSelected = (tokenPackage) => {
            return selectedTokenPackage.value.play_tokens === tokenPackage.star_packs.play_tokens
        }

        const openRequiredPurchaseMenu = (index) => {
                openPurchaseMenu(props.star_packs[index])
        }

        watch(stScript, (currentValue, oldValue) => {
            if (currentValue.exists) {
                createStComponent(currentValue.jwt)
            }
        })

        /**
         * @return {Object}
         */

        return {
            ShoppingBagIcon,
            isMobile,
            showForm,
            showTerms,
            formatter,
            selectedTokenPackage,
            form,
            openPurchaseMenu,
            openMobilePurchaseMenu,
            showMobilePurchaseMenu,
            purchase,
            paymentSuccesful,
            moment,
            paymentForm,
            validateResponse,
            useBalance,
            purchaseWithBalance,
            packageSelected,
            openRequiredPurchaseMenu,
            resubmitting,
            exchangeBoosters,
            boosters,
            products,
            getStoreProducts,
            isConfirmationModal,
            boosterConfirmationModal,
            selectedBooster,
            itemFilter,
            setFilter
        }

    },

}
</script>
